import { render, staticRenderFns } from "./StroeerLoader.vue?vue&type=template&id=78ddbd7c&"
import script from "./StroeerLoader.vue?vue&type=script&lang=js&"
export * from "./StroeerLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports